import { captureException } from '@sentry/react';
import { filter, get } from 'lodash';
import { useCallback } from 'react';
import { useCurrentClass } from 'store/classes/selectors';
import { useClassUsers, useUsersByClass } from 'store/userClasses/selectors';
import { getClassUsers } from 'store/userClasses/thunks';


const useGetStudentFromClass = () => {
  const usersByClass = useUsersByClass();
  const classUsers = useClassUsers();
  
  const getClassStudent = useCallback(
    (class_id) => {
      const classUser = get(usersByClass, class_id, []) || [];
      return classUser.filter((x) => x.role === 'student');
    },
    [usersByClass],
  );

  const getFetchStudent = async (class_id) => {
    try {
      if (!class_id) return;
      const studentsData = await getClassUsers(class_id);
      const filterStudent =
        filter(studentsData, (x) => x.role === "student" && x.active) || [];
        return filterStudent;
    } catch (error) {
      console.log(error);
    }
  };

  
  return {
    getClassStudent,
    classUsers,
    getFetchStudent
  };
};

export default useGetStudentFromClass;
